// extracted by mini-css-extract-plugin
export default {"container":"domain_container__59lat"};